import { init } from '@folio/stripes-core';

init();
